import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

export class AppHttpError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly body: unknown
  ) {
    super(message);
    this.name = 'AppHttpError';
  }
}

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMessage = 'An unknown error occurred';

        if (error.error instanceof ErrorEvent) {
          errorMessage = error.error.message;
        } else if (error.status === 401) {
          errorMessage = (error.error && error.error.message) ? error.error.message : 'Unauthorized';
          const isLoginRequest = request.url.includes('auth/login.php');
          if (!isLoginRequest && this.authService.isAuthenticated()) {
            this.authService.logout();
            errorMessage = 'Session expired. Please login again.';
          }
        } else if (error.status === 403) {
          errorMessage = (error.error && error.error.message) ? error.error.message : 'You do not have permission to perform this action';
        } else if (error.status === 404) {
          errorMessage = (error.error && error.error.message) ? error.error.message : 'Resource not found';
        } else if (error.status >= 500) {
          errorMessage = 'Server error. Please try again later.';
        } else if (error.error && error.error.message) {
          errorMessage = error.error.message;
        }

        if (error.status !== 401 || !request.url.includes('auth/login.php')) {
          console.error('HTTP Error:', errorMessage, error);
        }

        return throwError(() => new AppHttpError(errorMessage, error.status, error.error));
      })
    );
  }
}
